import React from "react";

/**
 * Zeferius Pay Logo
 * `variant`: "full" (logo header) or "mark" (icon only)
 */
export const Logo = ({ variant = "full", className = "", height = 32 }) => {
  const src = variant === "mark" ? "/logo-mark.png" : "/logo-header.png";
  const alt = "Zeferius Pay";
  return (
    <img
      src={src}
      alt={alt}
      style={{ height: `${height}px`, width: "auto" }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
};

export default Logo;
